import * as $ from 'jquery';
import * as signalR from '@microsoft/signalr';

interface JsonData {
    axMessage: string;
    deviceName: string;
    posGuestId: string;
    posWaiverId: string;
    result: any;
    serial: number;
    timestamp: any;
    unicode: number;
}

interface ResponseData {
    ShouldSendNotification: boolean;
}

export class OneRiskNotification {
    private notificationHub: signalR.HubConnection;

    constructor() {
        this.notificationHub = new signalR.HubConnectionBuilder()
            .withUrl("/notificationHub")
            .build();
    }

    public initialize() {
        this.notificationHub.on("notifyClients", this.onNotifyClients);

        this.notificationHub.start().then(() => {
            console.log("SignalR connection established.");
        }).catch(err => console.error("SignalR connection error: ", err.toString()));
    }

    private onNotifyClients(message: string) {
        console.log("Received notification:", message);
    }

    public sendNotification(message: string) {
        this.notificationHub.invoke("notify", message)
            .catch(err => console.error("Notification send error: ", err.toString()));
    }

    public triggerNotification() {
        const jsonData: JsonData = {
            axMessage: "acceptLiability",
            deviceName: "945-1",
            posGuestId: "04100080000000514",
            posWaiverId: "04100053000008841",
            result: null,
            serial: 11372,
            timestamp: null,
            unicode: 1
        };

        this.sendNotification("Initial check for notifications.");
    }
}

